
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return require("private-next-pages/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact"])
      });
    }
  